/*
 * Copyright (c) Ekathva Innovations Private Limited- All Rights Reserved
 * Unauthorized copying of this file, via any medium, is strictly prohibited
 * Proprietary and confidential
 *
 * Author: Nikitha S Bhatt (nikitha@ekathvainnovations.com), Akshay K Kulkarni (akshay.kulkarni@ekathvainnovations.com)
 *
 * Date:08-06-2021
 *
 * Filename: TestimonialPage
 * Page name: Testimonial page
 * Page Description: This is the Testimonial page of the website of Ekathva Innovations.
 */

import React, { useEffect } from "react";
import MetaTags from "react-meta-tags";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-multi-carousel/lib/styles.css";
import { Card, Col, Row, Image } from "react-bootstrap";
import Navbar from "components/Navbars/Navbar";
import LandingPageTestimonials from "components/Headers/LandingPageTestimonials";

import "assets/style/Style.css";

import { ReactComponent as Comma } from "assets/images/Testimonial/Invertedcomma.svg";

import { getImage } from "utils/imageUtilsTestimonial";

function TestimonialData(props) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { data } = props;

  return (
    <div>
      <MetaTags>
        <title>
          Testimonials - What our clients say about our work| Ekathva
          Innovations Pvt Ltd{" "}
        </title>
      </MetaTags>
      <Navbar />
      <LandingPageTestimonials />
      <br />
      <br />
      <br />
      <div className="homepage_spacing">
        <Row style={{ display: "flex" }}>
          <br />
          {data.data.map((t) => {
            const imageSrc = getImage(t.img);
            return (
              <Col>
                <Card key={t.id} className="testimonial_card_data">
                  <Row className="homepagetestimonial_imagestyle">
                    <Col md={2}></Col>
                    <Col md={6}>
                      <Comma
                        className="testimonial_commasize svgcolor"
                        roundedCircle
                      />
                    </Col>
                    <Col md={4}></Col>
                  </Row>

                  <div
                    data-aos="fade-up"
                    className="homepagetestimonial_contentpadding"
                  >
                    <Row>
                      <Col></Col>
                      <Col style={{ paddingLeft: 70 }}>
                        <Image
                          variant="top"
                          src={imageSrc}
                          alt="Image"
                          className="testimonial_imagesizing"
                          roundedCircle
                        />
                      </Col>
                      <Col></Col>
                    </Row>
                    <br />
                    <p className="homepagetestimonial_contentfont">
                      <strong>
                        {t.testimonial}
                        <br />
                      </strong>
                      <br />
                      <span className="it_ssnamecolor">{t.name},</span>
                      <span className="aboutus_fontbold">
                        <br />
                        {t.company},
                      </span>
                      {/* <strong>
                      <br />
                      {t.profession}
                    </strong> */}
                      <span>
                        <br />
                        {t.place}
                      </span>
                    </p>
                  </div>
                </Card>
              </Col>
            );
          })}
        </Row>
      </div>
    </div>
  );
}

export default TestimonialData;
